import { Controller } from "stimulus";
import Glide from "@glidejs/glide";
import { useDispatch } from "stimulus-use";

export default class extends Controller {
  connect() {
    useDispatch(this);

    this.overlay = document.querySelector('.first-block-overlay');

    this.glide = new Glide(this.element, {
      type: "carousel",
      startAt: 0,
      perView: 1,
      gap: 20,
      autoplay: false,
      hoverpause: true,
      swipeThreshold: 5,
      dragThreshold: 5,
      animationDuration: 5
    });
  
    const bullets = this.element.querySelectorAll('.glide__bullet');
    const bulletsContainer = this.element.querySelector('.glide__bullets');
  
    bullets[4].classList.add('glide__bullet--right');
  
    this.glide.on("run.after", () => {
      const activeBullet = this.element.querySelector('.glide__bullet--active');
      
      if (activeBullet && bulletsContainer) {
        const containerWidth = bulletsContainer.clientWidth;  
        const bulletOffsetLeft = activeBullet.offsetLeft;     
        const bulletWidth = activeBullet.clientWidth;         
      
        const scrollPosition = bulletOffsetLeft - (containerWidth / 2) + (bulletWidth / 2);
      
        bulletsContainer.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'  
        });
      
        this.updateDots();
      }
    });
    const preventSwipe = (event) => {
      if (!this.isOverlayOpen() && !this.isArrow(event.target)) {
        event.preventDefault();
      }
    };

    this.element.addEventListener('pointerdown', preventSwipe);
    this.glide.on('drag', preventSwipe);
    this.glide.on('swipe', preventSwipe);

    this.glide.on('mount.before', () => {
      document.querySelector(".controls.left").addEventListener("click", () => {
        this.glide.go("<");
      });

      document.querySelector(".controls.right").addEventListener("click", () => {
        this.glide.go(">");
      });
    })

    this.glide.mount();
  }

  updateDots() {
    const bullets = this.element.querySelectorAll('.glide__bullet');
    const activeIndex = Array.from(bullets).findIndex(bullet => bullet.classList.contains('glide__bullet--active'));

    bullets.forEach(bullet => {
      bullet.classList.remove('glide__bullet--left', 'glide__bullet--right');
    });

    if (activeIndex === 1) {
      bullets[activeIndex + 3].classList.add('glide__bullet--right');
      bullets[activeIndex - 1].classList.add('glide__bullet--left');
      return
    }

    if (activeIndex === bullets.length - 2) {
      bullets[bullets.length - 1].classList.add('glide__bullet--right');
      bullets[bullets.length - 5].classList.add('glide__bullet--left');
      return
    }

    if (activeIndex === bullets.length - 1) {
      bullets[bullets.length - 5].classList.add('glide__bullet--left');
      return
    }

    if (activeIndex === 0) {
      bullets[activeIndex + 4].classList.add('glide__bullet--right');
      return
    }
    if (activeIndex - 2 >= 0 && activeIndex !== bullets.length - 1) {
      bullets[activeIndex - 2].classList.add('glide__bullet--left');
    }

    if (activeIndex + 2 < bullets.length ) {
      bullets[activeIndex + 2].classList.add('glide__bullet--right');
    }
  }

  isOverlayOpen() {
    return this.overlay.classList.contains('open');
  }

  isArrow(target) {
    return target.closest('.glide__arrow');
  }

  openOverlay() {
    this.dispatch("openOverlay");
  }

  scrollTo3dTour() { 
    const threeDtour = document.querySelector('.component-3d-tour');
    if (!threeDtour) return;
    
    threeDtour.scrollIntoView({ behavior: 'smooth', block: "center" });
  }
}
